import { isTauri } from "@/lib/is-tauri";
import { useNotificationStore } from "@/stores/notification-store";
import { translate } from "@/i18n";
import { libPlanMessages } from "@/i18n/messages/lib-plan";

/** What a plan without the knowledge graph says wherever the graph would be.
 *  Getters, so each read (and each spread) is in the current app language. */
export const KNOWLEDGE_GRAPH_UPGRADE = {
  get title() {
    return translate(libPlanMessages, "knowledgeGraphTitle");
  },
  get description() {
    return translate(libPlanMessages, "knowledgeGraphDescription");
  },
};

/** Settings › Account in the web app; the desktop opens it through `tray-settings-billing`. */
export function openWebBillingSettings(): void {
  window.location.assign("/settings?tab=billing");
}

type UpgradeToast = {
  id: string;
  title: string;
  description?: string;
  persistent?: boolean;
};

/** The one toast every plan limit uses; Upgrade opens Settings › Account.
 *  A builder keeps the text in the current app language. */
export function showUpgradeToast(
  input: UpgradeToast | (() => UpgradeToast),
): void {
  const build = typeof input === "function" ? input : () => input;
  useNotificationStore.getState().addSystemToast(
    () => ({
      ...build(),
      level: "info",
      actionLabel: translate(libPlanMessages, "upgrade"),
      actionEvent: isTauri() ? "tray-settings-billing" : undefined,
    }),
    isTauri() ? undefined : openWebBillingSettings,
  );
}

/**
 * A server plan-limit message such as "Project limit reached (2 on Free
 * plan). Upgrade your plan for more." as a toast titled "Project limit
 * reached". Repeat refusals for the same limit replace that toast.
 */
export function showPlanLimitToast(message: string): void {
  const cut = message.search(/[(.]/);
  const title = (cut < 0 ? message : message.slice(0, cut)).trim();
  const description =
    cut < 0
      ? ""
      : message
          .slice(cut)
          .replace(/^\(([^)]*)\)/, "$1")
          .replace(/^\.\s*/, "")
          .trim();
  showUpgradeToast({
    id: `denker.plan-limit.${title}`,
    title,
    description: description || undefined,
  });
}
